<template>
  <div class="container-fluid">
    <div data-widget-group="group1">
      <ol class="breadcrumb">
        <li class="active"><router-link to="/admin">Dashboard</router-link></li>
        <li><router-link to="/allReborer">Reborer</router-link></li>

        <li class="active"><a href="#">Add Reborer</a></li>
      </ol>
      <form @submit.prevent="handleAddUser" autocomplete="off">
        <div class="panel-body locationform">
          <div v-if="message" class="alert-danger alert visibility" role="alert">
            {{ message }}
          </div>
          <div class="tab-content">
            <div class="col-md-12">
              <div class="tab-container tab-default">
                <ul class="nav nav-tabs">
                  <li class="active">
                    <a href="#home1" data-toggle="tab">Reborer Profile</a>
                  </li>
                  <li><a href="#profile1" data-toggle="tab">KYC</a></li>
                  <li><a href="#mapping" data-toggle="tab">Mapping</a></li>
                  <li>
                    <a href="#termsConditions" data-toggle="tab"
                      >Terms & Conditions</a
                    >
                  </li>
                </ul>
                <div class="tab-content">
                  <div class="tab-pane active" id="home1">
                    <div class="row">
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label>Shop Name *</label>
                          <input
                            v-model="register.ShopName"
                            v-validate="'required'"
                            type="text"
                            class="form-control"
                            name="ShopName"
                          />
                          <span v-if="errors.has('ShopName')">
                            {{ errors.first('ShopName') }}
                          </span>
                        </div>
                      </div>
                     
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label>First Name *</label>
                          <input
                            v-model="register.FirstName"
                            v-validate="'required'"
                            type="text"
                            class="form-control"
                            name="firstName"
                          />
                          <span v-if="errors.has('firstName')">
                            {{ errors.first('firstName') }}
                          </span>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label>Middle Name</label>
                          <input
                            v-model="register.MiddleName"
                            type="text"
                            class="form-control"
                            name="MiddleName"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label>Last Name *</label>
                          <input
                            v-model="register.LastName"
                            v-validate="'required'"
                            type="text"
                            class="form-control"
                            name="LastName"
                          />
                          <span v-if="errors.has('LastName')">
                            {{ errors.first('LastName') }}
                          </span>
                        </div>
                      </div>

                      <div class="col-sm-4">
                        <div class="form-group">
                          <label>Address line 1 *</label>
                          <input
                            v-model="register.AddressLine1"
                            v-validate="'required'"
                            type="text"
                            class="form-control"
                            name="AddressLine1"
                          />
                          <span v-if="errors.has('AddressLine1')">
                            {{ errors.first('AddressLine1') }}
                          </span>
                        </div>
                      </div>

                      <div class="col-sm-4">
                        <div class="form-group">
                          <label>Address line 2</label>
                          <input
                            v-model="register.AddressLine2"
                            type="text"
                            class="form-control"
                            name="AddressLine2"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label>Area </label>
                          <input
                            v-model="register.Area"
                            type="text"
                            class="form-control"
                            name="Area"
                          />
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label>Pin Code *</label>
                          <input
                        v-model="register.Zip"
                        v-validate="'required|between:111111,10000000'"
                        type="text"
                        class="form-control"
                        placeholder="Zip Code"
                        name="PinCode"
                        v-on:keyup="getCityState"
                      />
                      <span v-if="errors.has('PinCode')">
                        {{ errors.first('PinCode') }}
                      </span>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label>Country *</label>
                          <input
                        v-validate="'required'"
                        type="text"
                        class="form-control"
                        placeholder="Country"
                        v-model="register.Country"
                        name="Country"
                      />
                      <span v-if="errors.has('Country')">
                        {{ errors.first('Country') }}
                      </span>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label>City *</label>
                          <input
                            v-validate="'required'"
                            type="text"
                            class="form-control"
                            placeholder="City"
                            v-model="register.selectedCity"
                            name="City"
                          />
                          <span v-if="errors.has('City')">
                            {{ errors.first('City') }}
                          </span>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label>State *</label>
                          <input
                        v-validate="'required'"
                        type="text"
                        class="form-control"
                        placeholder="State"
                        v-model="register.State"
                        name="State"
                      />
                      <span v-if="errors.has('State')">
                        {{ errors.first('State') }}
                      </span>
                        </div>
                      </div>
                      
                    </div>
                  </div>

                  <div class="tab-pane" id="profile1">
                    <div class="row">
                      <div class="col-sm-4">
                        <file-upload
                          :labelName="'Upload Photo *'"
                          @imageUploadData="ProfileImageData"
                        ></file-upload>
                        <span v-if="errors.has('photoProfile')">
                        {{ errors.first('photoProfile') }}
                      </span>
                      </div>

                      <div class="col-sm-4">
                        <div class="form-group">
                          <label>Aadhar Card No</label>
                          <input
                            v-model="register.AadharCardNo"
                            type="text"
                            class="form-control"
                            name="AadharCardNo"
                          />
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label>Driving License No</label>
                          <input
                            v-model="register.DrivingLicenseNo"
                            type="text"
                            class="form-control"
                            name="DrivingLicenseNo"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label>PAN No</label>
                          <input
                            v-model="register.PANNo"
                            type="text"
                            class="form-control"
                            name="PANNo"
                          />
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label>Contact Number *</label>
                          <input
                            v-model="register.Mobile"
                            v-validate="'required'"
                            type="text"
                            class="form-control"
                            name="Mobile"
                          />
                          <span v-if="errors.has('Mobile')">
                            {{ errors.first('Mobile') }}
                          </span>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label>Alternate Contact Number</label>
                          <input
                            v-model="register.Mobile2"
                            type="text"
                            class="form-control"
                            name="Mobile2"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label>Email ID </label>
                          <input
                            v-model="register.Email"
                            type="text"
                            class="form-control"
                            name="Email"
                          />
                        </div>
                      </div>

                      <div class="col-sm-4">
                        <div class="form-group">
                          <label>Gender </label>
                          <div class="">
                            <label
                              ><input
                                v-model="register.Gender"
                                value="Male"
                                type="radio"
                              />
                              Male</label
                            >
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <label
                              ><input
                                v-model="register.Gender"
                                value="Female"
                                type="radio"
                              />
                              Female
                            </label>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label>Date of Birth </label>
                          <dobPicker @selectedDate="DOBSelected"></dobPicker>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label>Size of workshop *</label>
                          
                          <v-select
                            v-model="register.SizeOfWorkshop"
                            :reduce="(seg) => seg.value"
                            :label="'text'"
                            :options="optionsSizeOfWorkshop"
                          >
                          </v-select>
                        </div>
                      </div>
                     
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label>Service per month</label>
                          <v-select
                            v-model="register.BajajServicePerMonth"
                            :reduce="(seg) => seg.value"
                            :label="'text'"
                            :options="optionsBajajServicePerMonth"
                          ></v-select>
                        </div>
                      </div>
                    
                      <div class="col-sm-4">
                        <div class="form-group">
                          <label>Year Of Experience</label>
                          <v-select
                            v-model="register.YearOfExperience"
                            :reduce="(seg) => seg.value"
                            :label="'text'"
                            :options="optionsYearOfExperience"
                          ></v-select>
                        </div>
                      </div>
                      </div>
                    <div class="row">
                      <div class="col-sm-4">
                        <file-upload
                          :labelName="'Workshop Photo'"
                          @imageUploadData="WorkShopImageData"
                        ></file-upload>
                      </div>
                    </div>
                  </div>

                  <div class="tab-pane" id="mapping">
                    <div class="row">
                      
                      <div class="col-md-4 col-sm-4">
                        <div class="form-group">
                          <label>Items</label>
                          <div class="">
                        <label
                          ><input
                            value="spare-BGO"
                            v-model="register.Items"
                            type="radio"
                            name="Items"
                            v-validate="'required'"
                          />
                          Spare/ BGO</label
                        >
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <label
                          ><input
                            value="Referal"
                            v-model="register.Items"
                            type="radio"
                            name="Items"
                            v-validate="'required'"
                          />
                          Referal
                        </label>
                       
                      </div>
                        </div>
                      </div>

                      <div class="col-md-4 col-sm-4">
                        <div class="form-group">
                          <label>Retailer Mapping</label>
                          <retailerMultiselect :preSelect="register.retailer" @selectedData="getRetailerSelected" :remoteControl="'bajajAPI/User/retailer'"></retailerMultiselect>
                        </div>
                      </div>
                      <div class="col-md-4 col-sm-4">
                        <div class="form-group">
                          <label>Dealer Mapping</label>
                          <retailerMultiselect :preSelect="register.dealer" @selectedData="getDealerSelected"  :remoteControl="'bajajAPI/User/dealer'"></retailerMultiselect>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="tab-pane" id="termsConditions">
                    <div class="row">
                   <div class="col-sm-12">
                                                                    <div class="tranms-text">
                                                                        <p>Terms & Conditions</p>
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-12">
                                                                    <div class="tranms-text">
                                                                        <div class="checkbox1 checkbox-inline">
                                                                            <label><input
                          type="checkbox"
                          
                          v-model="termsAccept"
                          true-value="Accepted"
                          false-value="Not Accepted"
                          
                          name="terms"
                        /> Bank account
                                                                                link with BHIM UPI for further
                                                                                transactions</label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="col-md-12">
                                                                    <div class="checkbox checkbox-inline">
                                                                        Mobile number to receive OTP and authorized same
                                                                        to submit all details to dealer for approva
                                                                    </div>
                                                                </div>
                    
                       
                    </div>
                    <div class="row">
                      <div class="col-sm-3 col-sm-offset-9">
                        <div class="form-group">
                          <button
                            class="btn-raised btn-primary btn fixcolorAs"
                            :disabled="loading"
                          >
                            <span
                              v-show="loading"
                              class="spinner-border spinner-border-sm"
                            ></span>
                            <span>Submit</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div id="externalScript"></div>
  </div>
</template>
<script>
import UserService from '../services/user.service';
import postscribe from 'postscribe';
import fileUpload from './components/file_upload';
import searchSelect from './components/Select2Search';
import dobPicker from './components/date_picker';

import retailerMultiselect from './components/retailerMultiselect'

import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

// import 'bootstrap/dist/css/bootstrap.css';
// import datePicker from 'vue-bootstrap-datetimepicker';
// import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';

function initialState() {
  return {
    ShopName:'',
    MechanicId: '',
    FirstName: '',
    MiddleName: '',
    LastName: '',
    AddressLine1: '',
    AddressLine2: '',
    Mobile: '',
    Mobile2: '',
    Email: '',
    Zip: '',
    Area: '',
    
    
    ProfilePicture: '',
    selectedCity: '',
    State:'',
    Country:'',
    AadharCardNo: '',
    DrivingLicenseNo: '',
    PANNo: '',
    Gender: '',
    DateOfBirth: '',
    SizeOfWorkshop: null,
    // NoOfVehicleRepairPerMonth: null,
    BajajServicePerMonth: null,
    YearOfExperience: null,
    WorkshopPhoto: '',
    
    Items:'spare',
    retailer:[],
    dealer:[],
  };
}
export default {
  name: 'addReborer',
  data() {
    return {
      BreadcrumbItems: [
        { text: 'Home' },
        { text: 'All Users' },
        { text: 'Add User', active: true },
      ],
      DOBOptions: {
        format: 'DD/MM/YYYY',
        useCurrent: false,
      },

      selectedCity: null,
      optionsCustomerSegment: [
        { value: null, text: 'Please select Type' },
        { value: 'prime', text: 'Prime' },
        { value: 'Silver', text: 'Silver' },
      ],
      optionsSizeOfWorkshop:[
        { value: null, text: 'Please select Size' },
        { value: '100', text: 'Upto 100 Sqft' },
        { value: '100-200', text: '100-200 Sqft' },
        { value: '200-300', text: '200-300 Sqft' },
        { value: '300+', text: 'More than 300 Sqft' },
      ],
     
      optionsBajajServicePerMonth:[
        { value: null, text: 'Please select Vehicle Service' },
        { value: '100', text: 'Upto < 100' },
        { value: '101-300', text: '100-300' },
        { value: '301-500', text: '300-500' },
        { value: '501+', text: '500' },
      ],
      GenderOptions: [
        { item: 'male', name: 'Male' },
        { item: 'female', name: 'FeMale' },
      ],
      optionsYearOfExperience:[ 
        { value: null, text: 'Please select Vehicle Service' },
        { value: 1, text: '1 Year' },
        { value: 2, text: '2 Year' },
        { value: 3, text: '3 Year' },
        { value: 4, text: '4 Year' },
        { value: 5, text: '5 Year' },
        { value: 6, text: '6 Year' },
        { value: 7, text: '7 Year' },
        { value: 8, text: '8 Year' },
        { value: 9, text: '9 Year' },
        { value: 10, text: '10 Year' },
      ],
      selectedCustomerSegment: null,
      termsAccept: 'Not Accepted',
      loading: false,
      message: '',
      register: initialState(),
    };
  },
  components: {
    fileUpload,
    searchSelect,
    vSelect,
    dobPicker,
    retailerMultiselect
  },
  beforeCreate() {
    this.$store.commit('SET_LAYOUT', 'app-layout');
  },
  methods: {
    getRetailerSelected(selected){
      this.register.retailer = selected
    },
    getDealerSelected(selected){
      this.register.dealer = selected
    },
     getCityState(){
      if(this.register.Zip.length > 5){
        /*Call API Get City And State*/
        var param = {}
        param.zip = this.register.Zip
        UserService.getMetod("kspgAPI/CommonData/zipToAddress",param).then(
            (response) => {
              this.register.selectedCity =""
              this.register.State =""
              this.register.Country=""
              // this.message = response.data.message;
              // this.loading = false;
              // // on success reset values
              if (response.data.country) {
                this.register.Country= response.data.country
              }
              if (response.data.city) {
                this.register.selectedCity= response.data.city
              }
              if (response.data.state) {
                this.register.State = response.data.state
              }
            },
            (error) => {
              this.loading = false;

              this.message =
                (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                error.message ||
                error.toString();
            }
          );
      }
    },
    getCitySelected(cityName) {
      // this.register.selectedCity = cityName;
    },
    ProfileImageData(imageData) {
      // console.warn(imageData.path);
      // console.warn(imageData.url)
      this.register.ProfilePicture = imageData.path;
      this.message = 'Picture Upload Successfully';
    },
    WorkShopImageData(imageData) {
      this.register.WorkshopPhoto = imageData.path;
      this.message = 'WorkShop Photo Upload Successfully';
    },
    DOBSelected(dobdate) {
      this.register.DateOfBirth = dobdate;
    },
   
    handleAddUser(e) {
       this.$validator.validateAll().then((res) => {
            if (this.termsAccept != 'Accepted') {
            this.message = 'Please accept Agreement';
            setTimeout(() => (this.message = false), 5000);
            return true;
          }

          
        // if (this.register.ProfilePicture == '') {
        //   this.errors.add({
        //     field: 'photoProfile',
        //     msg: 'Please Upload Photo',
        //   });
        //   res = false;
        // }
          if (!res) {
          // handle input errors.
          this.message = 'Please Fill all menditory Options';
            setTimeout(() => (this.message = false), 5000);
          return;
        }
        /*bajajAPI/user/add_mechanics*/
         UserService.postMetod('kspgAPI/Reborer/addReborer', this.register).then(
        (response) => {
          this.message = response.data.message;
          this.loading = false;
          // on success reset values
          if (response.data.status) {
            this.resetWindow();
          }
        },
        (error) => {
          this.loading = false;

          this.message =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
        }
      );
       });
      // Hide Messages
      setTimeout(() => (this.message = false), 5000);
    },
    resetWindow: function () {
      Object.assign(this.$data.register, initialState());
    },
  },
  created() {},
  mounted() {
    postscribe(
      '#externalScript',
      /* eslint-disable-next-line */
      `<\script type="application/javascript" src="assets/js/Utility_ApplicationUsed.js"><\/script>`
    );
  },
};
</script>
<style scoped>
.tab-container {
  font-size: small;
}
.radio1 > label {
  padding: 10px;
}
.btn-primary {
  color: cyan;
}

.visibility {
  visibility:visible !important;
}

</style>